/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
    init: (app, gsap) => {

        /*
        |
        | Constants
        |------------
        */
        const
            $body = $('body'),
            header = document.querySelector('header'),
            width = $(window).width()
        ;

        /*
        |
        | Sticky sidebar
        |--------------
        */
        const $termsContainer = $('.terms-container');

        if ( width > 991) {
            
            gsap.to($termsContainer, {
                scrollTrigger: {
                    trigger: $termsContainer,
                    start: `top ${header.offsetHeight + 10}px`,
                    end: "+=200",
                    pin: true,
                }
            });

        }

    }
}
